import EventBus from '@dc-post-grid/assets/js/event-bus';

export const Searchable = {
	props: {
		filters: {
			type: Array,
			required: false,
		},
		lang: {
			type: String,
			required: false,
		},
		dc_s: {
			type: String,
			required: false,
		},
		searchButtonId: {
			type: String,
			required: true,
		},
		initialModel: {
			type: Object,
			required: false,
		},
		currentPaged: {
			type: Number,
			required: true,
		},
		gridSettings: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			readyToSearch: false,
			timeout: null,
			needsRefresh: false,
			previousTerm: '',
			initialPaged: null,
			previousPaged: '2',
			previousForm: {},
			disabledFilters: [],
		};
	},
	computed: {
		isQueryable() {
			return (
				typeof this.gridSettings !== 'undefined' &&
				typeof this.gridSettings.queryable !== 'undefined' &&
				this.gridSettings.queryable
			);
		},
	},
	methods: {
		toggleTextSearchFocused() {
			this.textSearchFocused = !this.textSearchFocused;
		},
		doTextSearch() {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this.refreshQuery();
				this.search();
			}, 250);
		},
		updateSearchTerm(newVal) {
			if (typeof newVal === 'undefined' || newVal === '') {
				this.form['dc_s'] = null; //this.form.dc_s = null;
			} else {
				this.form['dc_s'] = newVal; //this.form.dc_s = newVal;
			}
			// If the newVal is different than oldVal, and newVal is !empty
			if (typeof newVal !== 'undefined' && newVal !== this.previousTerm) {
				this.doTextSearch();
			}
		},
		updateAndSearch(name, value, usesMultiselect) {
			if (this.previousForm[name] !== value) {
				this.refreshQuery();
				this.previousForm[name] = [value];
				if (typeof this.form[name] === 'undefined') {
					this.form[name] = []; //this.form[name] = [];
				}
				if (usesMultiselect) {
					let newValues = Object.values({ ...this.form[name] });
					if (newValues.includes(value)) {
						const index = newValues.indexOf(value);
						if (index > -1) {
							newValues.splice(index, 1);
						}
					} else {
						newValues.push(value);
					}
					this.form[name] = newValues; //this.form[name].push(value);
				} else {
					this.form[name] = [value]; //this.form[name] = [value];
				}
     			EventBus.$emit('filters-updated', name, this.form, Object.values({ ...this.disabledFilters }));
				this.search();
			}
		},
		resetAndSearch(name) {
			this.refreshQuery();
			this.form[name] = [];
			this.search();
		},
		refreshQuery() {
			this.form.paged = 1;
			this.$emit('update-current-paged', this.initialPaged);
			this.previousYear = this.form.year;
			if (typeof this.filters !== 'undefined') {
				for (var i = 0; i < this.filters.length; i++) {
					this.previousForm[this.filters[i].name] = this.form[this.filters[i].name];
				}
			}
			this.previousTerm = this.form.dc_s;
		},
		serialize(obj) {
			let str =
				'?' +
				Object.keys(obj)
					.reduce(function (a, k) {
						a.push(k + '=' + encodeURIComponent(obj[k]));
						return a;
					}, [])
					.join('&');
			return str;
		},
		updateFinalFilterValuesBeforeSearch(formValues) {
			formValues = this.excludeDisabledFilterValues(formValues);
			formValues = this.setFilterValuesFromInitialModelForEmptyValues(formValues);
			formValues.post_id = window.dcpgData.post_id;
			return formValues
		},
		excludeDisabledFilterValues(formValues) {
			const keys = Object.keys(formValues);
			keys.forEach((key) => {
				if (this.disabledFilters.includes(key)) {
					delete formValues[key];
				}
			})
			return formValues;
		},
		setFilterValuesFromInitialModelForEmptyValues(formValues) {
			/** 
			 * Sometimes the options for a filter are not all the options available 
			 * in WordPress, because we have used include or exclude in the block to modify 
			 * the options that appear in the dropdown. To make sure that when no value is 
			 * selected the search only searches the pre-defined categories for our block, 
			 * not all of the possible option values for that filter, we reset the form values 
			 * to all of the initial options from the filter which already has the 
			 * categories included/excluded as they are set in the block.
			 */
			this.filters.forEach((filter) => {
				if (filter.type!=='default') return;
				if (typeof formValues[filter.name] !== 'undefined' && formValues[filter.name].length>0) return; //The user has chosen a value, so we submit that.
				let values = [];
				if (typeof filter.options !== 'undefined') {
					filter.options.forEach((option) => {
						if ( typeof option.value !== 'undefined' && option.value !== null && option.value !== '' ) {
							values.push(option.value);
						}
					})
				}
				if (formValues.length>0) {
					formValues[filter.name] = values;
				}
			})
			return formValues;
		},
		getUrlFriendlyKey(key) {
			if (key === 'post_type') return 'dc_post_type'; //'post_types';
			if (key === 'post_types') return 'dc_post_type';
			if (key === 'paged') return 'dc_page';
			return key;
		},
		updateUrlSearchHistory(formValues) {
			let queryString = '';
			for (let [key, value] of Object.entries(formValues)) {
				const paramKey = this.getUrlFriendlyKey(key);
				if (this.disabledFilters.includes(paramKey)) continue;
				if (
					(paramKey === 'dc_page' && ['0', 0].includes(value)) ||
					value.length === 0 ||
					[
						'posts_per_page', 
						'order', 
						'orderby', 
						'total_posts', 
						'total_pages', 
						//'post_types',
						'end_of_results',
						'post_navigation_type'
					].includes(
						paramKey
					)
				)
					continue;
				queryString += queryString === '' ? '?' : '&';

				queryString += paramKey + '=';
				if (typeof value === 'string' || typeof value === 'number') {
					queryString += value;
				} else {
					if (value && typeof value === 'object') {
						value = Object.values(value);
					}
					if (value && Array.isArray(value)) {
						const filteredValues = this.removeEmptyArrayValues(value);
						if (filteredValues.length>0) {
							queryString += filteredValues.join(',');
						}
					}
				}
			}
			if (queryString === '') {
				queryString = '?dc_page=1';
			}
			history.replaceState(null, '', queryString);
		},
		removeEmptyArrayValues(array) {
			return array.filter(function (val) {
				return typeof val !== 'undefined' && val != null && val !== '';
			});
		},
		search() {
			if (this.readyToSearch === false) return;
			// if (typeof this.form.dc_s === 'undefined') return
			this.$emit('searching');
			let formValues = this.form;
			if (formValues['dc_s'] === null || typeof formValues['dc_s'] === 'undefined') {
				delete formValues['dc_s'];
			}
			let formValuesFinal = this.updateFinalFilterValuesBeforeSearch({ ...formValues });
			axios.post(window.dcpgData.searchEndpoint + this.serialize(formValuesFinal)).then((response) => {
				if (response.data.success) {
					if (this.isQueryable) {
						this.updateUrlSearchHistory(formValuesFinal);
					}
					this.form.paged = response.data.paged;
					this.needsRefresh = this.form.paged <= this.previousPaged;
					const resultData = {
						paged: response.data.paged,
						posts: response.data.posts,
						endOfResults: response.data.endOfResults,
						needsRefresh: this.needsRefresh,
					};
					if (typeof response.data.totalPosts !== 'undefined') {
						this.$emit('update-total-posts', response.data.totalPosts);
					}
					if (typeof response.data.totalPages !== 'undefined') {
						this.$emit('update-total-pages', response.data.totalPages);
					}
					this.$emit('results', resultData);
					this.previousPaged = this.form.paged;
				} else {
					this.$emit('error');
				}
			});
		},
		setInitialModelsFromFilters() {
			if (typeof this.filters !== 'undefined' && this.filters !== null) {
				for (var i = 0; i < this.filters.length; i++) {
					const value = this.filters[i].value[0] === '' ? [] : this.filters[i].value;
					this.form[this.filters[i].name] = value; //this.form[this.filters[i].name] = value;
					this.previousForm[this.filters[i].name] = value;
				}
			}
			this.readyToSearch = true;
		},
		initSearchModel() {
			//this.form.dc_s = this.$route.params.dc_s
			this.initialPaged = this.currentPaged;
			this.setInitialModelsFromFilters();
			if (typeof this.lang !== 'undefined') {
				this.form['lang'] = this.lang; //this.form.lang = this.lang;
			}
			if (
				this.filters.some((e) => e.name === 'sites') &&
				this.filters.find((f) => f.name === 'sites').type !== 'hidden'
			) {
				this.form.initial_sites = this.filters.find((f) => f.name === 'sites').options.map((f) => f.value);
			}

			if (typeof this.dc_s !== 'undefined') {
				this.form['dc_s'] = this.dc_s; //this.form.dc_s = this.dc_s;
			}
			if (typeof this.initialModel !== 'undefined') {
				for (const [key, value] of Object.entries(this.initialModel)) {
					this.form[key] = value; //this.form[key] = value;
				}
				['post_type', 'category'].forEach((fieldName) => {
					if (typeof this.initialModel[fieldName] !== 'undefined' && this.initialModel[fieldName].length > 0) {
						EventBus.$emit('filters-updated', fieldName, this.initialModel, this.disabledFilters);
					} 
				})
			}
		},
		handleUpdateDisabledFilters(disabledFilters) {
			this.disabledFilters = disabledFilters;
		},
	},
	mounted() {
		EventBus.$on('disabled-filters-updated', this.handleUpdateDisabledFilters);
		this.initSearchModel();
	},
	beforeDestroy() {
		EventBus.$off('disabled-filters-updated', this.handleUpdateDisabledFilters);
	},
	watch: {
		currentPaged(newVal, prevVal) {
			if (prevVal === null) {
				this.initialPaged = newVal;
				return;
			}
			this.form.paged = newVal;
			this.search();
		},
	},
};
